var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { forwardRef } from 'react';
/* eslint-disable no-restricted-imports */
import { TouchableOpacity } from 'react-native';
/* eslint-enable no-restricted-imports */
import { useSccEventLogging } from '@/hooks/useSccEventLogging';
export const SccTouchableOpacity = forwardRef((_a, ref) => {
    var { elementName, logParams, disableLogging, trackView, onPress } = _a, props = __rest(_a, ["elementName", "logParams", "disableLogging", "trackView", "onPress"]);
    const { createPressHandler } = useSccEventLogging({
        elementName,
        logParams,
        disableLogging,
        trackView,
    });
    const handlePress = createPressHandler(onPress);
    return _jsx(TouchableOpacity, Object.assign({ ref: ref, onPress: handlePress }, props));
});
SccTouchableOpacity.displayName = 'SccTouchableOpacity';
export default SccTouchableOpacity;
